export default __webpack_public_path__ + "static/media/portfolio-210.5ccea7dd.jpg";